import { Trans } from '@lingui/react/macro';
import { AppError } from 'shared/domains/errors';
export function NotFoundError() {
    return <AppError code={404} message={<Trans>Ooops, the page you were searching for does not exist...</Trans>}/>;
}
